<template>
  <div
    :class="[
      Classes.SECTION,
      'tw-relative game-tile-background-color',
      {
        'tw-animate-pulse': panelLoading,
        'game-tile-border game-tile-radius': !noBorder,
      },
    ]"
  >
    <header
      v-if="title"
      class="tw-tracking-wide tw-text-md xl:tw-text-h5 tw-text-[var(--tile-border-text)] tw-bg-[var(--tile-border-color)] tw-font-medium tw-capitalise tw-px-4 tw-py-1.5 tw-rounded-t-[calc(var(--tile-border-radius)-var(--tile-border-width))]"
    >
      <loading-label v-if="panelLoading" />
      <div
        v-else
        class="tw-flex tw-justify-between tw-items-center"
        :class="{ 'tw-cursor-pointer': expandable }"
        @click="expandable && handleToggle()"
      >
        <span>{{ title }}</span>
        <base-button
          v-if="expandable"
          xsmall
          icon-size="lg"
          :icon="show ? 'angle-up' : 'angle-down'"
        />
      </div>
    </header>

    <div
      v-if="show"
      :class="{
        'tw-flex': flex,
        'tw-w-full': fullWidth,
        'tw-h-full': fullHeight,
        'tw-py-4': paddingY,
        'tw-px-4': paddingX,
      }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import LoadingLabel from '@components/Loading/LoadingLabel.vue'
import Classes from '@shared/js/config/css.js'
import { ref } from 'vue'

export default {
  components: {
    LoadingLabel,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    paddingY: {
      type: Boolean,
      default: true,
    },
    paddingX: {
      type: Boolean,
      default: true,
    },
    panelLoading: {
      type: Boolean,
      default: false,
    },
    flex: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    expandable: {
      type: Boolean,
      default: false,
    },
    toggled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:toggle'],
  setup(props, { emit }) {
    const show = ref(props.toggled || !props.expandable)

    function handleToggle() {
      show.value = !show.value
      emit('update:toggle', show.value)
    }

    return {
      handleToggle,
      Classes,
      show,
    }
  },
}
</script>
